var _rect, _rect2, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVTailDarkLogo = function SvgVTailDarkLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.441,
    width: 60,
    height: 60,
    rx: 14,
    fill: "#212240"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.191,
    width: 60.5,
    height: 60.5,
    rx: 14.25,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.441c0-7.732 6.268-14 14-14h32c7.732 0 14 6.268 14 14v32c0 7.732-6.268 14-14 14H15c-7.732 0-14-6.268-14-14v-32Z",
    fill: "url(#vTailDarkLogo_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.22 16.45c-2.917-.02-4.157 0-4.157 0s-2.306.305-3.52 3.056c-.685 1.55-3.911 8.902-6.745 15.359l4.57 10.416.01.016c.352-.41.638-.876.85-1.378 1.197-2.776 10.583-24.711 10.583-24.711s1.273-2.739-1.59-2.758Z",
    fill: "#3BE5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m30.798 34.86-4.569 10.443a4.353 4.353 0 0 0 2.799 1.5s.707.015 3.175 0c1.8-.01 3.165-1.527 3.165-1.527l-.024-.055-4.546-10.36Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.21 45.288a4.627 4.627 0 0 1-.341-.447 5.468 5.468 0 0 1-.506-.927 58021.496 58021.496 0 0 1-10.581-24.707s-1.274-2.738 1.593-2.756c2.92-.02 4.157 0 4.157 0s2.307.305 3.52 3.056l6.746 15.359-4.57 10.442-.019-.02Z",
    fill: props.fill || '#009EFF'
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "vTailDarkLogo_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(106.205 29.959 23.619) scale(61.3464 92.2883)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};

export default SvgVTailDarkLogo;